import { Component, OnDestroy, OnInit } from '@angular/core';
import { OnlineClientService } from '../../services/online-client.service';
import { Observable, pipe, take } from 'rxjs';
import { Router } from '@angular/router';

@Component({
  selector: 'tx-content-update',
  templateUrl: './content-update.component.html',
  styleUrl: './content-update.component.scss'
})
export class ContentUpdateComponent implements OnInit, OnDestroy {

  private checkContentSwitchLockInterval: any;

  constructor(private onlineClientService: OnlineClientService, private router: Router) {

  }

  ngOnInit(): void {
    this.checkContentSwitchLockInterval = setInterval(this.checkContentSwitchLock.bind(this), 1000);
  }

  ngOnDestroy(): void {
    if (this.checkContentSwitchLockInterval) {
      clearInterval(this.checkContentSwitchLockInterval);
    }
  }

  private checkContentSwitchLock() {
    this.onlineClientService.hasContentSwitchLock()
    .pipe(take(1))
    .subscribe((res: boolean) => {
      if (res === false) {
        this.router.navigate(['']);
      }
    }, (error) => {
      console.log(error)
    });
  }

}
